import { PARAGRAPH_KEY, HEADING_KEY } from '@techchange/pm-specs';

/**
 * Determines if the specified mark type is included in the
 * current selection.
 *
 * @param {Object} markType  The mark type to check.
 * @param {Object} state     The current editor state.
 *
 * @returns {boolean} Whether or not the mark type is within
 * the selection.
 *
 */
const selectionContainsMark = (markType, state) => {

	const paragraphNodeType = state.schema.nodes[PARAGRAPH_KEY];
	const headingNodeType = state.schema.nodes[HEADING_KEY];

	const { from, to } = state.selection;

	let containsMarkType = false;

	state.doc.nodesBetween(from, to, (node, nodePos) => {

		if (node.type === paragraphNodeType || node.type === headingNodeType) {

			node.forEach((inlineNode, inlinePos) => {

				const start = nodePos + 1 + inlinePos;
				const end = start + inlineNode.nodeSize;

				const selected = from >= start && to <= end;

				// Check if this text node is within the selection
				if (selected) {

					const hasMark = inlineNode.marks.find((mark) => mark.type === markType);

					if (hasMark) {

						containsMarkType = true;

					}

				}

			});

		}

		// Recurse to children if we still haven't found a mark type
		return !containsMarkType;

	});

	return containsMarkType;

};

export default selectionContainsMark;
